<template>
  <div id="data-list-list-view" class="data-list-container">
    <side-view
      :isSidebarActive="isSidebarActive"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
      @onUpdated="onUpdated"
      @onInserted="onInserted"
    />
    <vx-card ref="listCard" :title="$t('Decarbonization.ComplexityParameter.Title')" title-color="black" refresh-content-action @refresh="refreshList"> 
      <vs-table
            ref="table"
            v-model="selected"
            pagination
            :max-items="itemsPerPage"
            search
            :data="complexityParameters"            
          >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
              <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-add"
                @click="addNewData"
              >{{$t('AddNew')}}</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <Pager
                :currentPage="currentPage"
                :itemsPerPage="itemsPerPage"
                :totalCount="complexityParameters.length"
                :queriedItems="queriedItems"
                :pageSizes="[10,20,50]"
                @pageChanged="onPageChanged"
              ></Pager>
            </vs-col>
          </vs-row>
        </div>
        <template slot="thead">
          <vs-th>{{$t('Action')}}</vs-th>
          <vs-th sort-key="code">{{$t('Decarbonization.ComplexityParameter.Name')}}</vs-th>
          <vs-th sort-key="formula">{{$t('Decarbonization.ComplexityParameter.Formula')}}</vs-th>
          <vs-th sort-key="constant">{{$t('Decarbonization.ComplexityParameter.Constant')}}</vs-th>
          <vs-th sort-key="exponent">{{$t('Decarbonization.ComplexityParameter.Exponent')}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td width="100px" class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(tr)"
                  v-b-tooltip.hover :title="$t('Edit')"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="openDeleteConfirm(tr.id, tr.code)"
                  v-b-tooltip.hover :title="$t('Delete')"
                />       
              </vs-td>
              <vs-td>
                <p class="font-medium truncate">{{ tr.name }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ tr.constant }} * tonnage<sup>{{ tr.exponent }}</sup></p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ tr.constant }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ tr.exponent }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
<script>

import sideView from "./components/sideView.vue";
import module from "../../store/module.js";
import { Pager } from "@/app/shared/components";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    Pager,
    sideView
  },
  data() {
    return {
      selected: [],    
      itemsPerPage: 20,
      isMounted: false, 
      // Data Sidebar
      isSidebarActive: false,
      sidebarData: {}
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    complexityParameters() {
      return this.$store.state.decarbonization.complexityParameters;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.complexityParameters.length;
    }
  },
  methods: {
    refreshList() {
      this.$store.dispatch("decarbonization/fetchAllComplexityParameters").finally(() => {
        this.$refs.listCard.removeRefreshAnimation();
      });
    },
    onPageChanged(val) {
      this.itemsPerPage = val;
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    openDeleteConfirm(id) {
      this.$deleteConfirmation({
        text: this.$t('Decarbonization.ComplexityParameter.ConfirmDelete'),
        accept:  () => this.deleteData(id)
      });
    },
    deleteData(id) {
      this.$store.dispatch("decarbonization/removeComplexityParameter", id)
        .then(() => {
          this.$notifyDeleteSuccess(this.$t("Decarbonization.ComplexityParameter.DeletedConfirmation"));
        });
    },
    editData(model) {
      this.sidebarData = model;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.isSidebarActive = val;
    },
    onUpdated() {
      this.$notifySaveSuccess();
      this.toggleDataSidebar(false);

    },

    onInserted() {
      this.$notifySuccess(this.$t('InsertSuccess'));
      this.toggleDataSidebar(false);
    }
  },
  created() {
    if (!module.isRegistered) {
      this.$store.registerModule("decarbonization", module);
      module.isRegistered = true;
    }
  },
  mounted() {
    if (!this.isMounted) {
      this.$refs.listCard.refreshcard();
    }
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
.vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.8rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 8px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--tbody-table {
      min-width: 200px;
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>